module.exports = "/images/vendor/flag-icon-css/flags/4x3/do.svg?79f8bf8c1a68481e09267f5215ef80ca";